import ABCyaPhaser from "@abcya/abcya_phaser";
import gameData from "../gameData";
import FontKeys from "../FontKeys";
import ABCyaLib from "@abcya/abcya_lib";

export default class Rocket extends Phaser.GameObjects.Container
{
    constructor(scene)
    {
        super(scene);
        scene.add.existing(this);

        this.scene = scene;

        this.isOver = false;
        this.flames = [];
        this.fireworks = [];
        this.rocketArr = ["blue_rocket", "green_rocket", "orange_rocket", "purple_rocket", "red_rocket"];
		
        this.createItem();
    }

	createItem() 
    {
        this.fire = this.scene.add.sprite(-80, 120).play('burn').setAngle(-103).setScale(2, 2.5);
        this.add(this.fire);

        if(gameData.GAME_STATE == "intro"){
            this.cont = this.scene.add.container();
            this.add(this.cont);

            this.body = ABCyaPhaser.Images.addImage(0, 0, "rocketIntro", this.cont).setAngle(-10);
            this.setPosition(-this.body.width, ABCyaLib.Environment.instance.gameConfig.titleRocketYPosition);
            if(!gameData.DESKTOP) {
              this.y = ABCyaLib.Environment.instance.gameConfig.mobileTitleRocketYPosition;
            }
            ABCyaPhaser.Text.addText(218, 55, 104, 0xffd493, FontKeys._ostrich_sansheavy, ABCyaPhaser.Localization.instance.getLocalizedString('rocket_text'), this.cont).setAngle(-10);

            this.moveRocket("in");
            this.moveRocket("wobble");
        }
        else if(gameData.GAME_STATE == "game"){
            this.body = ABCyaPhaser.Images.addImage(0, 0, this.rocketArr[Phaser.Math.Between(0,4)], this);

            this.fire.setPosition(-3, this.fire.height/2 - 15).setAngle(180).setScale(.75);
        }
	};

    setWord(newWord){
        this.word = ABCyaPhaser.Text.addText(0, -75, 50, 0xFFD493, gameData.GAME_FONTS[2], newWord, this);

        this.rocketWord = this.innerText = newWord;
    };

    moveRocket(type, init){
        if(type == "in"){
          const x = gameData.DESKTOP ? ABCyaLib.Environment.instance.gameConfig.titleRocketStopXPosition : ABCyaLib.Environment.instance.gameConfig.mobileTitleRocketStopXPosition;
          const y = gameData.DESKTOP ? ABCyaLib.Environment.instance.gameConfig.titleRocketYPosition : ABCyaLib.Environment.instance.gameConfig.mobileTitleRocketYPosition;
          this.contTween = ABCyaPhaser.Tweens.addTween(this, 2000, {x: x, y:y}, Phaser.Math.Easing.Linear, ()=>{
                this.moveRocket("backForth");
            });
        }

        if(type == "backForth"){
          const x = gameData.DESKTOP ? ABCyaLib.Environment.instance.gameConfig.titleRocketStopXPosition : ABCyaLib.Environment.instance.gameConfig.mobileTitleRocketStopXPosition;
          const y = gameData.DESKTOP ? ABCyaLib.Environment.instance.gameConfig.titleRocketYPosition : ABCyaLib.Environment.instance.gameConfig.mobileTitleRocketYPosition;
          this.contTween = ABCyaPhaser.Tweens.addTween(this, 2000, {y:y - Phaser.Math.Between(10, 20), x: x - 30}, Phaser.Math.Easing.Cubic.Out, ()=>{
              this.contTween = ABCyaPhaser.Tweens.addTween(this, 3000, {y:y + Phaser.Math.Between(10, 20), x: x + 30}, Phaser.Math.Easing.Cubic.InOut, ()=>{
                  this.contTween = ABCyaPhaser.Tweens.addTween(this, 2000, {y:y, x: x}, Phaser.Math.Easing.Cubic.In, ()=>{
                        this.moveRocket("backForth");
                    });
                });
            });
        }
        //reset the X position of the cloud when it get to the other side. Tween across with a random time between 10-15 seconds
        if(type == "wobble"){
            this.contTween = ABCyaPhaser.Tweens.addTween(this.cont, 50, {y:Phaser.Math.Between(0, 5), x: Phaser.Math.Between(0, 5)}, Phaser.Math.Easing.Cubic.Out, ()=>{
                this.moveRocket("wobble");
            });
        }

        if(type == "fly"){
            if(gameData.GAME_STATE == "game" && !gameData.GAME_DONE){
                const randWait = Phaser.Math.Between(100, 3000);
                const randSpeed = Phaser.Math.Between(5000, gameData.SPEED);

                if(init){
                    this.contTween = ABCyaPhaser.Tweens.addTween(this, randSpeed, {y:-this.body.height}, Phaser.Math.Easing.Linear, ()=>{
                        this.destroyRocket(true);
                    });
                } else {
                    this.contTween = ABCyaPhaser.Tweens.addTween(this, randSpeed, {y:-this.body.height, delay:randWait}, Phaser.Math.Easing.Linear, ()=>{
                        this.destroyRocket(true);
                    });
                }
            }
        }

        if(gameData.GAME_PAUSED){
            this.toggleMovement(true);
        }
    };

    toggleMovement(type){
        //tween the clouds
        if(type){
            if(this.contTween) this.contTween.resume();
            if(this.createTween) this.createTween.resume();
        } else {
            if(this.contTween) this.contTween.pause();
            if(this.createTween) this.createTween.pause();
        }
    };

    triggerFirework(){
        //console.log("rocketX = " + this.x + " rocketY = " + this.y);
        this.scene.explode(this.x, this.y);
    };

    stopRocket(){
        //stop the rocket's tweens
        this.scene.tweens.killTweensOf(this);
        if(this.contTween) this.contTween.pause();
        if(this.cont) this.scene.tweens.killTweensOf(this.cont);
    };

    destroyRocket(respawn){
        //Destroy the rocket
        this.stopRocket();
        this.fireworks = [];

        if(gameData.GAME_STATE == "game"){
            gameData.ROCKETPOS_ARR.push(this.x);
            Phaser.Utils.Array.Shuffle(gameData.ROCKETPOS_ARR);

            gameData.WORD_BANK.push(this.innerText);
            Phaser.Utils.Array.Shuffle(gameData.WORD_BANK);

            if(gameData.ROCKET_ARR.indexOf(this) != -1){
                gameData.ROCKET_ARR.splice(gameData.ROCKET_ARR.indexOf(this), 1);
            }

            if(respawn){
                if(!gameData.GAME_DONE) this.scene.createRockets();
            }

            this.cont?.removeAll();
            this.removeAll(true);

            this.scene.destroyRocket(this);
        } else {
            this.removeAll(true);
        }
    };
}